var marketplace_car_insurance_br = require("./marketplace-car-insurance-br");
var marketplace_car_insurance_cl = require("./marketplace-car-insurance-cl");
var marketplace_car_insurance_co = require("./marketplace-car-insurance-co");
var marketplace_car_loan_cl = require("./marketplace-car-loan-cl");
var marketplace_car_loan_co = require("./marketplace-car-loan-co");
var marketplace_checking_account_br = require("./marketplace-checking-account-br");
var marketplace_checking_account_cl = require("./marketplace-checking-account-cl");
var marketplace_consumer_loan_cl = require("./marketplace-consumer-loan-cl");
var marketplace_consumer_loan_co = require("./marketplace-consumer-loan-co");
var marketplace_country_selector = require("./marketplace-country-selector");
var marketplace_credit_card_br = require("./marketplace-credit-card-br");
var marketplace_credit_card_cl = require("./marketplace-credit-card-cl");
var marketplace_credit_card_co = require("./marketplace-credit-card-co");
var marketplace_health_insurance_cl = require("./marketplace-health-insurance-cl");
var marketplace_home_br = require("./marketplace-home-br");
var marketplace_home_cl = require("./marketplace-home-cl");
var marketplace_home_co = require("./marketplace-home-co");
var marketplace_international_liability_cl = require("./marketplace-international-liability-cl");
var marketplace_life_insurance_br = require("./marketplace-life-insurance-br");
var marketplace_life_insurance_cl = require("./marketplace-life-insurance-cl");
var marketplace_life_insurance_co = require("./marketplace-life-insurance-co");
var marketplace_mandatory_car_insurance_cl = require("./marketplace-mandatory-car-insurance-cl");
var marketplace_mandatory_health_insurance_covid_19_cl = require("./marketplace-mandatory-health-insurance-covid-19-cl");
var marketplace_mortgage_loan_cl = require("./marketplace-mortgage-loan-cl");
var marketplace_mortgage_loan_co = require("./marketplace-mortgage-loan-co");
var marketplace_personal_loan_br = require("./marketplace-personal-loan-br");
var marketplace_savings_account_cl = require("./marketplace-savings-account-cl");
var marketplace_savings_account_co = require("./marketplace-savings-account-co");
var marketplace_soat_co = require("./marketplace-soat-co");
var marketplace_travel_insurance_br = require("./marketplace-travel-insurance-br");
var marketplace_travel_insurance_cl = require("./marketplace-travel-insurance-cl");
var marketplace_travel_insurance_co = require("./marketplace-travel-insurance-co");
var messages = {
 "marketplace_car_insurance_br": marketplace_car_insurance_br,
"marketplace_car_insurance_cl": marketplace_car_insurance_cl,
"marketplace_car_insurance_co": marketplace_car_insurance_co,
"marketplace_car_loan_cl": marketplace_car_loan_cl,
"marketplace_car_loan_co": marketplace_car_loan_co,
"marketplace_checking_account_br": marketplace_checking_account_br,
"marketplace_checking_account_cl": marketplace_checking_account_cl,
"marketplace_consumer_loan_cl": marketplace_consumer_loan_cl,
"marketplace_consumer_loan_co": marketplace_consumer_loan_co,
"marketplace_country_selector": marketplace_country_selector,
"marketplace_credit_card_br": marketplace_credit_card_br,
"marketplace_credit_card_cl": marketplace_credit_card_cl,
"marketplace_credit_card_co": marketplace_credit_card_co,
"marketplace_health_insurance_cl": marketplace_health_insurance_cl,
"marketplace_home_br": marketplace_home_br,
"marketplace_home_cl": marketplace_home_cl,
"marketplace_home_co": marketplace_home_co,
"marketplace_international_liability_cl": marketplace_international_liability_cl,
"marketplace_life_insurance_br": marketplace_life_insurance_br,
"marketplace_life_insurance_cl": marketplace_life_insurance_cl,
"marketplace_life_insurance_co": marketplace_life_insurance_co,
"marketplace_mandatory_car_insurance_cl": marketplace_mandatory_car_insurance_cl,
"marketplace_mandatory_health_insurance_covid_19_cl": marketplace_mandatory_health_insurance_covid_19_cl,
"marketplace_mortgage_loan_cl": marketplace_mortgage_loan_cl,
"marketplace_mortgage_loan_co": marketplace_mortgage_loan_co,
"marketplace_personal_loan_br": marketplace_personal_loan_br,
"marketplace_savings_account_cl": marketplace_savings_account_cl,
"marketplace_savings_account_co": marketplace_savings_account_co,
"marketplace_soat_co": marketplace_soat_co,
"marketplace_travel_insurance_br": marketplace_travel_insurance_br,
"marketplace_travel_insurance_cl": marketplace_travel_insurance_cl,
"marketplace_travel_insurance_co": marketplace_travel_insurance_co };
function getMessages(businessUnitCode) {
        var code = "marketplace_" + businessUnitCode.replace(/-/g, "_");
        return messages[code] ? messages[code] : {};
      }
module.exports = getMessages;